// src/store/patientSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PatientDetails } from "../../interface/GeneralResponse";

interface PatientState {
  patientDetails: PatientDetails | null;
}

const initialState: PatientState = {
  patientDetails: null,
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setPatientDetails(state, action: PayloadAction<PatientDetails>) {
      state.patientDetails = action.payload;
    },
    clearPatientDetails(state) {
      state.patientDetails = null;
    },
  },
});

export const { setPatientDetails, clearPatientDetails } = patientSlice.actions;

export default patientSlice.reducer;
